import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Utils/NewIcon';
import DefaultModal from 'components/Utils/DefaultModal';
import PatientSearch from 'components/Patient/PatientSearch';

const PatientSearchModal = ({ backButton, onSelect, onClose, open, initialValue }) => {
  let backButtonContent = backButton ? (
    <div onClick={backButton} className="back-button">
      <Icon src="arrow-left" />
    </div>
  ) : null;

  return (
    <DefaultModal
      className="modal"
      wrap={true}
      padding={false}
      title="Patient Search"
      content={
        <div className="patient-search-modal">
          {backButtonContent}
          <div className="content">
            <PatientSearch onSelect={onSelect} initialValue={initialValue} />
          </div>
        </div>
      }
      isOpen={open}
      onRequestClose={onClose}
    />
  );
};

PatientSearchModal.propTypes = {
  backButton: PropTypes.func,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
};

export default PatientSearchModal;
